// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 826 ? "index" : chunkId) + "." + {"631":"244ee62956ca33c78db8","826":"7cbfd7d5020da4404d69"}[chunkId] + ".css";
};